
import {wxShareConfig} from './js/common/utils'
import $ from 'zepto'
import wx from 'wx'
import ViewBox from 'vux/src/components/view-box/index.vue'

import axios from 'axios'

export default {
ready () {



},
computed: {},
mounted(){

},
data()
{
return {
defaultShareImg: 'url(' + require('../src/assets/logo.png') + ')',
isIndex: true
}
}
,
components: {
ViewBox
}
}



// WEBPACK FOOTER //
// ./src/main.vue